module.exports = __webpack_public_path__ + "static/media/covid19Outdoors.3169ec4b.png";